import { RouteConfig } from "vue-router";
import { Roles } from "@/models/emums/roles";

const routes: Array<RouteConfig> = [
    {
        path: "/logistic-load",
        component: require("@/layouts/layout.vue").default,
        children: [
            {
                path: "list",
                name: "Logistic load list",
                component: require("@/components/logistic-load/logistic-load-list.vue").default,
                meta: {
                    roles: [Roles.Admin, Roles.User, Roles.Disponent, Roles.DisponentAdmin]
                }
            }
        ]
    }
];

export default routes;
